// extracted by mini-css-extract-plugin
export default {"errorText":"Combobox_errorText__ZF67F"};